<!-- <div class="contact-container">
  <h1>{{ "Frequently Asked Questions" | translate }}</h1>
  <p>
    {{
      "If you have any question , we hope you will find helpful answer and you can search about your questions"
        | translate
    }}
  </p>
  <div class="mx-0 mx-md-5">
    <p-accordion
      [multiple]="true"
      expandIcon="bi bi-plus-circle fs-4"
      collapseIcon="bi bi-dash-circle fs-4
    "
    >
      <p-accordionTab class="m-1" *ngFor="let item of data" [header]="item.ask">
        <p [innerHTML]="item.answer"></p>
      </p-accordionTab>
    </p-accordion>
  </div>
</div> -->
<div class="faq-container">
  <h2 class="faq-title">{{ "faqPage.title" | translate }}</h2>

  <p-accordion [multiple]="true" class="faq-accordion">
    <p-accordionTab [header]="'faqPage.q1' | translate">
      <p>{{ "faqPage.a1" | translate }}</p>
    </p-accordionTab>

    <p-accordionTab [header]="'faqPage.q2' | translate">
      <p>{{ "faqPage.a2" | translate }}</p>
    </p-accordionTab>

    <p-accordionTab [header]="'faqPage.q3' | translate">
      <p>{{ "faqPage.a3" | translate }}</p>
    </p-accordionTab>
  </p-accordion>
</div>
